import { useQuery } from '@tanstack/react-query';
import { useSite } from '../../../context/page-context';
import { useBillingApi } from './use-billing-api';

export const QK_BILLING_DATA = (siteId: string) => ['billing', 'data', siteId] as const;

export function useBillingData() {
  const { billingApi } = useBillingApi();
  const { siteId } = useSite();

  return useQuery({
    queryKey: QK_BILLING_DATA(siteId),
    queryFn: () => billingApi.data(siteId),
  });
}
